const sign_up_and_sign_in = {
    identifiers_email: 'ที่อยู่อีเมล',
    identifiers_phone: 'หมายเลขโทรศัพท์',
    identifiers_username: 'ชื่อผู้ใช้',
    identifiers_email_or_sms: 'ที่อยู่อีเมลหรือหมายเลขโทรศัพท์',
    identifiers_none: 'ไม่มี',
    and: 'และ',
    or: 'หรือ',
    sign_up: {
        title: 'สมัครสมาชิก',
        sign_up_identifier: 'ตัวระบุการสมัครสมาชิก',
        identifier_description: 'ตัวระบุที่เลือกสำหรับการสมัครสมาชิกทั้งหมดต้องกรอกขณะสร้างบัญชีใหม่',
        sign_up_authentication: 'การตั้งค่าการยืนยันตัวตนสำหรับการสมัครสมาชิก',
        verification_tip: 'ผู้ใช้ต้องยืนยันอีเมลหรือหมายเลขโทรศัพท์ที่คุณตั้งค่าไว้ด้วยการกรอกรหัสยืนยันระหว่างสมัครสมาชิก',
        authentication_description: 'การดำเนินการที่เลือกทั้งหมดจะเป็นข้อบังคับสำหรับผู้ใช้ในการดำเนินขั้นตอนให้เสร็จสมบูรณ์',
        set_a_password_option: 'สร้างรหัสผ่านของคุณ',
        verify_at_sign_up_option: 'ยืนยันตัวตนในขั้นตอนสมัครสมาชิก',
        social_only_creation_description: '(ใช้สำหรับการสร้างบัญชีด้วยโซเชียลเท่านั้น)',
    },
    sign_in: {
        title: 'เข้าสู่ระบบ',
        sign_in_identifier_and_auth: 'การตั้งค่าตัวระบุและการยืนยันตัวตนสำหรับการเข้าสู่ระบบ',
        description: 'ผู้ใช้สามารถเข้าสู่ระบบด้วยตัวเลือกที่มีอยู่',
        add_sign_in_method: 'เพิ่มวิธีเข้าสู่ระบบ',
        add_sign_up_method: 'เพิ่มวิธีสมัครสมาชิก',
        password_auth: 'รหัสผ่าน',
        verification_code_auth: 'รหัสยืนยัน',
        auth_swap_tip: 'สลับตัวเลือกด้านล่างเพื่อตัดสินใจว่าจะให้ตัวเลือกใดแสดงก่อนในกระบวนการ',
        require_auth_factor: 'คุณต้องเลือกปัจจัยการยืนยันตัวตนอย่างน้อยหนึ่งรายการ',
        forgot_password: 'ลืมรหัสผ่าน',
        forgot_password_description: 'ผู้ใช้สามารถรีเซ็ตรหัสผ่านได้โดยใช้วิธีการยืนยันใดก็ได้ที่มี',
        add_verification_method: 'เพิ่มวิธีการยืนยันตัวตน',
        email_verification_code: 'รหัสยืนยันอีเมล',
        phone_verification_code: 'รหัสยืนยันโทรศัพท์',
    },
    social_sign_in: {
        title: 'เข้าสู่ระบบผ่านโซเชียล',
        social_sign_in: 'เข้าสู่ระบบด้วยโซเชียล',
        description: 'ขึ้นอยู่กับตัวระบุที่คุณกำหนด ผู้ใช้อาจต้องระบุตัวตนเมื่อสมัครผ่านตัวเชื่อมต่อโซเชียล',
        add_social_connector: 'เพิ่มตัวเชื่อมต่อโซเชียล',
        set_up_hint: {
            not_in_list: 'ไม่มีในรายการ?',
            set_up_more: 'ตั้งค่า',
            go_to: 'ตัวเชื่อมต่อโซเชียลอื่น ๆ ตอนนี้',
        },
        settings_title: 'ประสบการณ์การใช้งานการเข้าสู่ระบบผ่านโซเชียล',
        automatic_account_linking: 'เชื่อมโยงบัญชีที่มีตัวระบุเดียวกันโดยอัตโนมัติ',
        automatic_account_linking_tip: 'เมื่อเปิดใช้งาน ถ้าผู้ใช้เข้าสู่ระบบด้วยตัวตนโซเชียลใหม่และมีบัญชีที่มีตัวระบุเดียวกัน (เช่น ที่อยู่อีเมล) Logto จะเชื่อมโยงตัวตนโซเชียลกับบัญชีนั้นโดยอัตโนมัติ ผู้ใช้จะไม่ถูกถามว่าต้องการเชื่อมบัญชีหรือไม่',
        required_sign_up_identifiers: 'บังคับให้ผู้ใช้กรอกข้อมูลการสมัครที่ขาดหาย',
        required_sign_up_identifiers_tip: 'เมื่อเปิดใช้งาน ผู้ใช้ที่เข้าสู่ระบบผ่านผู้ให้บริการโซเชียลต้องกรอกข้อมูลการสมัครที่ขาดหาย (เช่น อีเมล) ก่อนทำการเข้าสู่ระบบ \n\nถ้าปิด ผู้ใช้สามารถดำเนินการต่อโดยไม่ต้องกรอกตัวระบุที่ขาดหาย แม้ว่าบัญชีโซเชียลจะไม่ได้ซิงค์ข้อมูลดังกล่าว',
    },
    tip: {
        set_a_password: 'จำเป็นต้องตั้งรหัสผ่านสำหรับชื่อผู้ใช้ของคุณ',
        verify_at_sign_up: 'ขณะนี้เรารองรับเฉพาะการยืนยันอีเมลและโทรศัพท์เท่านั้น ผู้ใช้อาจให้ที่อยู่อีเมลหรือเบอร์โทรที่ไม่ถูกต้องหากไม่มีการยืนยัน',
        password_auth: 'จำเป็นมากหากคุณเปิดใช้งานตัวเลือกการตั้งรหัสผ่านระหว่างสมัครสมาชิก',
        verification_code_auth: 'จำเป็นมากหากคุณเปิดแค่ตัวเลือกการกรอกรหัสยืนยันในขั้นตอนสมัครสมาชิก คุณสามารถไม่ติ๊กช่องนี้ได้เมื่ออนุญาตให้ตั้งรหัสผ่านในขั้นตอนสมัครสมาชิก',
        email_mfa_enabled: 'รหัสยืนยันอีเมลถูกเปิดใช้งานแล้วสำหรับ MFA และจะไม่สามารถใช้เป็นวิธีการเข้าสู่ระบบหลักได้เพื่อความปลอดภัย',
        phone_mfa_enabled: 'รหัสยืนยันโทรศัพท์ถูกเปิดใช้งานแล้วสำหรับ MFA และจะไม่สามารถใช้เป็นวิธีการเข้าสู่ระบบหลักได้เพื่อความปลอดภัย',
        delete_sign_in_method: 'จำเป็น เนื่องจากคุณเลือก {{identifier}} ให้เป็นตัวระบุที่ต้องใช้',
        password_disabled_notification: 'ตัวเลือก "สร้างรหัสผ่านของคุณ" ถูกปิดใช้งานในขั้นตอนสมัครสมาชิกด้วยชื่อผู้ใช้ ซึ่งอาจทำให้ผู้ใช้เข้าสู่ระบบไม่ได้ กรุณายืนยันหากต้องการบันทึก',
    },
    advanced_options: {
        title: 'ตัวเลือกขั้นสูง',
        enable_single_sign_on: 'เปิดใช้งาน Single Sign-On (SSO) สำหรับองค์กร',
        enable_single_sign_on_description: 'อนุญาตให้ผู้ใช้เข้าสู่ระบบแอปพลิเคชันด้วย Single Sign-On โดยใช้บัญชีองค์กรของพวกเขา',
        single_sign_on_hint: {
            prefix: 'ไปที่ ',
            link: '"Enterprise SSO"',
            suffix: ' เพื่อดูตัวเชื่อมต่อองค์กรเพิ่มเติม',
        },
        enable_user_registration: 'เปิดใช้งานการลงทะเบียนผู้ใช้',
        enable_user_registration_description: 'เปิดหรือปิดให้มีการลงทะเบียนผู้ใช้ เมื่อปิด ผู้ดูแลระบบยังสามารถเพิ่มผู้ใช้ผ่านแผงควบคุมได้ แต่ผู้ใช้จะไม่สามารถสร้างบัญชีใหม่ผ่านหน้าล็อกอินได้อีก',
        unknown_session_redirect_url: 'URL สำหรับเปลี่ยนเส้นทางเมื่อเซสชันไม่รู้จัก',
        unknown_session_redirect_url_tip: 'บางครั้ง Logto อาจไม่รู้จักเซสชันของผู้ใช้บนหน้าล็อกอิน เช่น กรณีเซสชันหมดอายุหรือผู้ใช้บุ๊กมาร์ก/แชร์ลิงก์เข้าสู่ระบบ ปกติจะขึ้นข้อผิดพลาด “unknown session” 404 เพื่อปรับประสบการณ์ผู้ใช้ ให้ตั้งค่า URL สำรองเพื่อเปลี่ยนเส้นทางผู้ใช้กลับไปยังแอปและเริ่มยืนยันตัวตนใหม่',
    },
};
export default Object.freeze(sign_up_and_sign_in);
